var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(-27.434 -312.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(29.953 318.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M55.648,192.08a1.659,1.659,0,0,1-.465,1.16,1.559,1.559,0,0,1-1.124.481h-5.2v3.25a1.342,1.342,0,0,1-1.32,1.364h-3.2a1.343,1.343,0,0,1-1.322-1.364v-3.25H17.055a1.616,1.616,0,0,1-1.589-1.641,1.663,1.663,0,0,1,.465-1.161,1.559,1.559,0,0,1,1.124-.48H43.017v-3.25a1.343,1.343,0,0,1,1.322-1.364h3.2a1.342,1.342,0,0,1,1.32,1.364v3.25h5.2A1.615,1.615,0,0,1,55.648,192.08Z",
    transform: "translate(-15.466 -175.636)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M55.645,177.135a1.671,1.671,0,0,1-.462,1.273,1.561,1.561,0,0,1-1.124.48H28.242a.01.01,0,0,0-.01.01v3.221a1.352,1.352,0,0,1-1.331,1.373H23.725a1.353,1.353,0,0,1-1.331-1.374V178.9a.01.01,0,0,0-.01-.01H17.125a1.652,1.652,0,0,1-1.194-2.8,1.559,1.559,0,0,1,1.124-.48h5.329a.01.01,0,0,0,.01-.01v-3.24a1.352,1.352,0,0,1,1.331-1.373H26.9a1.352,1.352,0,0,1,1.331,1.373v3.24a.01.01,0,0,0,.01.01H53.99A1.656,1.656,0,0,1,55.645,177.135Z",
    transform: "translate(-15.466 -170.983)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M55.648,207.032a1.665,1.665,0,0,1-.465,1.161,1.561,1.561,0,0,1-1.124.48H38.49v3.26a1.343,1.343,0,0,1-1.322,1.364h-3.2a1.343,1.343,0,0,1-1.321-1.364v-3.26H17.056a1.616,1.616,0,0,1-1.59-1.641,1.662,1.662,0,0,1,.465-1.16,1.559,1.559,0,0,1,1.125-.481H32.651V202.15a1.342,1.342,0,0,1,1.321-1.362h3.2a1.342,1.342,0,0,1,1.322,1.362v3.241H54.059A1.615,1.615,0,0,1,55.648,207.032Z",
    transform: "translate(-15.466 -180.327)",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3987",
    "data-name": "Rectangle 3987",
    width: 45,
    height: 45,
    transform: "translate(27.434 312.54)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.762d555723f3d178152030ffb0768d8c.svg";
export { ForwardRef as ReactComponent };